import { PeriodKpi } from "@/api/periodData";
import { StatGroup, STAT_LABELS, formatValue } from "./periodDataUtils";
import { getTeamLogo } from "@/lib/utils";

interface PeriodStatGroupCardProps {
    group: StatGroup;
    homePeriod: PeriodKpi | undefined;
    awayPeriod: PeriodKpi | undefined;
    homeTeamName?: string;
    awayTeamName?: string;
}

export const PeriodStatGroupCard = ({
    group,
    homePeriod,
    awayPeriod,
    homeTeamName,
    awayTeamName,
}: PeriodStatGroupCardProps) => {
    const homeLogo = homeTeamName ? (getTeamLogo(homeTeamName) ?? null) : null;
    const awayLogo = awayTeamName ? (getTeamLogo(awayTeamName) ?? null) : null;

    return (
        <div className="bg-surface-container-lowest rounded-xl overflow-hidden shadow-sm flex flex-col flex-1">
            <div className="flex items-center justify-between px-4 py-2 bg-surface-container-high border-b border-outline-variant/10">
                <div className="flex items-center gap-1.5">
                    {homeLogo && <img src={homeLogo} alt="" className="h-5 w-5 object-contain" />}
                    <span className="text-[9px] font-black uppercase tracking-widest" style={{ color: "#050066" }}>
                        {homeTeamName ?? "Home"}
                    </span>
                </div>
                <div className="flex items-center gap-1.5">
                    <span className="text-[9px] font-black uppercase tracking-widest" style={{ color: "#ba0a06" }}>
                        {awayTeamName ?? "Away"}
                    </span>
                    {awayLogo && <img src={awayLogo} alt="" className="h-5 w-5 object-contain" />}
                </div>
            </div>

            <div className="flex flex-col divide-y divide-surface-container">
                {group.fields.map((field) => {
                    const homeVal = homePeriod?.[field] ?? 0;
                    const awayVal = awayPeriod?.[field] ?? 0;
                    const sum = homeVal + awayVal;
                    const homePct = sum > 0 ? (homeVal / sum) * 100 : 50;
                    const homeWins = homeVal > awayVal;
                    const awayWins = awayVal > homeVal;

                    return (
                        <div key={field} className="px-4 py-2.5">
                            <div className="flex items-center justify-between gap-2 mb-1.5">
                                <span
                                    className={`font-headline font-black tabular-nums text-sm ${
                                        homeWins ? "" : "text-on-surface-variant"
                                    }`}
                                    style={homeWins ? { color: "#050066" } : undefined}
                                >
                                    {formatValue(homeVal, field)}
                                </span>
                                <span className="text-[10px] text-on-surface-variant font-medium text-center flex-1 truncate px-1">
                                    {STAT_LABELS[field]}
                                </span>
                                <span
                                    className={`font-headline font-black tabular-nums text-sm ${
                                        awayWins ? "" : "text-on-surface-variant"
                                    }`}
                                    style={awayWins ? { color: "#ba0a06" } : undefined}
                                >
                                    {formatValue(awayVal, field)}
                                </span>
                            </div>
                            <div className="h-1 w-full rounded-full overflow-hidden flex">
                                <div
                                    className="h-full transition-all duration-500"
                                    style={{ width: `${homePct}%`, background: "#050066" }}
                                />
                                <div
                                    className="h-full transition-all duration-500 flex-1"
                                    style={{ background: "#ba0a06" }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
